import React from "react";
import { ConfirmAppointmentTemplate } from "../../Templates/ConfirmAppointmentTemplate";

export const ConfirmAppointment = () => {
  return <ConfirmAppointmentTemplate />;
};
